module.exports = __webpack_public_path__ + "img/lock.019d4357.svg";